export const scrollConfig = {
  duration: 800,
  delay: 0,
  smooth: "easeInOutQuart",
  offset: -120,
};
